import type { ComponentProps } from "react"

export type ExternalLinkProps = ComponentProps<"a">

function ExternalLink(props: ExternalLinkProps) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a target="_blank" rel="noopener noreferrer" {...props} />
  )
}

export default ExternalLink
